var _rect, _path, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgShadowIconTwelve(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 66,
    height: 66,
    viewBox: "0 0 66 66",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 65.9999,
    height: 65.9999,
    fill: "#D1AD6E"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M40.1181 66.0039L19.8491 46.2037L19.1206 45.4156L17.125 38.3705L19.0082 40.2656L18.5225 39.1743V38.3255L18.7046 37.1736L18.7046 37.1736L19.6134 35.0718L18.4599 34.0411L22.4398 31.0256L23.7598 30.161L23.256 29.5547C23.256 29.5547 25.2594 28.3421 25.8058 27.4327C26.0267 27.0191 26.2542 27.3795 26.5223 27.8041C26.8436 28.3131 27.2233 28.9145 27.7198 28.3856C28.6304 27.4156 31.0198 27.3956 31.0198 27.3956L32.1748 26.5706L33.3298 25.7456L32.9998 24.0956L34.0148 23.2491L33.3304 19.4756L38.6098 15.5156L43.1448 19.1878L66.0004 39.1743V55.7302V66.0039H40.1181Z",
    fill: "#BB8A34"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4491_301)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M26.9709 48.8357C33.0237 48.8357 38.0311 43.8625 38.0311 37.7086C38.0311 36.0596 37.6691 34.5111 37.0256 33.1036C35.256 33.8678 34.0092 35.6372 34.0092 37.7086C34.0092 41.5522 30.8629 44.8139 26.9709 44.8139C23.0898 44.8139 19.9326 41.5897 19.9326 37.7086C19.9326 33.8275 23.0898 30.6703 26.9709 30.6703C27.3127 30.6703 27.6547 30.6904 27.9965 30.7507C28.8008 29.4637 29.8063 28.3376 31.0129 27.4126C29.7661 26.93 28.3987 26.6484 26.9709 26.6484C20.8577 26.6484 15.8438 31.5954 15.8438 37.7086C15.8438 43.8217 20.8577 48.8357 26.9709 48.8357Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.3113 15.6284C36.8503 14.1673 34.4868 14.1506 33.0031 15.5754C31.5215 14.1506 29.157 14.1673 27.695 15.6284C26.2162 17.1072 26.2162 19.5118 27.695 20.9905L33.0031 26.3657L38.3113 20.9905C39.79 19.5118 39.79 17.1071 38.3113 15.6284Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.0367 44.8139C38.6949 44.8139 38.3529 44.7938 38.0111 44.7335C37.2068 46.0204 36.2013 47.1466 34.9947 48.0716C36.2415 48.5542 37.6089 48.8357 39.0367 48.8357C45.1499 48.8357 50.1639 43.8217 50.1639 37.7086C50.1639 31.5954 45.1499 26.6484 39.0367 26.6484C32.9654 26.6484 27.9766 31.5746 27.9766 37.7086C27.9766 39.3575 28.3385 40.9731 28.982 42.3806C30.7517 41.6164 31.9984 39.7799 31.9984 37.7086C31.9984 33.8649 35.1447 30.6703 39.0367 30.6703C42.9178 30.6703 46.075 33.8275 46.075 37.7086C46.075 41.5897 42.9178 44.8139 39.0367 44.8139Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4491_301"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 34.3199,
    height: 34.3199,
    fill: "white",
    transform: "translate(15.8438 14.5234)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShadowIconTwelve);
export default __webpack_public_path__ + "static/media/shadow-icon-twelve.4f4db5f0e78dd66ed9d0067e89402d10.svg";
export { ForwardRef as ReactComponent };